import "../item.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Summary ??= {};

AppointmentBooking.Wizard.Views.Summary.DoctorItem = class DoctorItem extends (
  AppointmentBooking.Wizard.Views.Summary.Item
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize() {
    super.initialize(...arguments);
    return this.listenTo(this.model, "change:provider change:validated_provider", this.render);
  }

  render() {
    super.render(...arguments);
    this.$el.toggleClass(
      "appointment-booking-wizard-summary-doctor-item--pcp-change",
      this.model.get("provider").gid !== this.model.get("validated_provider").gid,
    );

    return this;
  }
};
AppointmentBooking.Wizard.Views.Summary.DoctorItem.prototype.template = "summary/doctor";
AppointmentBooking.Wizard.Views.Summary.DoctorItem.prototype.className =
  "appointment-booking-wizard-summary-doctor-item";
